// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems } from './shared';

export const label = 'Contents - Specified Items';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/43564690',
  policyDetailsId: '1218178927625',
  forename: 'Albert',
  coverType: 'Contents',
  specifiedItems: mockSpecifiedItems
});
